import { useCallback, useContext, useEffect, useState } from "react";
import { AppContext } from "../app-context";
import FavouritesService, { FavouritesServiceResponse } from "../services/favourites-service";
import { useVehicleStore } from "../store/vehicles";

const useFetchFavourites = (id?: string) => {
  const [loading, setLoading] = useState<boolean>(true);

  const { globalApi } = useContext(AppContext);
  const vehicleStore = useVehicleStore();
  const [vehicleResponse, setVehicleResponse] = useState<FavouritesServiceResponse | null>(null);

  const fetchFavourites = useCallback(async () => {
    const favService = new FavouritesService(globalApi, id);
    const response = await favService.request(null);

    if (response) {
      vehicleStore.setVehicle(null);
      vehicleStore.setResponse(null);

      if (response) {
        setLoading(false);

        if(response.data?.length) {
          vehicleStore.setResponse(response);
          setVehicleResponse(response);
        }
        else {
          setVehicleResponse(null);
        }
      }
    }
  }, []);

  useEffect(() => {
    fetchFavourites();
  }, []);

  return [loading, vehicleResponse];
}

export default useFetchFavourites;

